import React, { useState } from "react";
import Hero from "../../designSystem/Hero";
import CustomSelect from "../../designSystem/CustomSelect";
// import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import InvestmentWorthCalculator from "../../calculators/InvestmentWorthCalculator";
import "../../../css/calculators/InvestmentPage.css";
import InvestmentGoalMonthlyCalculator from "../../calculators/InvestmentGoalMonthlyCalculator";
import InvestmentGoalTimeCalculator from "../../calculators/InvestmentGoalTimeCalculator";
import SEO from "../../designSystem/SEO";

const calculatorOptions = [
  { value: "", label: "Please select" },
  {
    value: "investment-worth",
    label: "What could my investments be worth?",
  },
  {
    value: "investment-goal-monthly",
    label: "How much might I need to invest each month to reach my goal?",
  },
  {
    value: "investment-goal-time",
    label: "How long could it take me to reach my goal?",
  },
];

const InvestmentPage = () => {
  const [selectedCalculator, setSelectedCalculator] = useState("");

  return (
    <div>
      <SEO
        title="Investment Calculators"
        description="Use investment calculators to estimate future value, monthly contributions and how long it could take to reach a financial goal."
        path="/calculators/investment"
      />
      <Hero title="Investment" subtitle="" showContactButton={false} />
      
      <div className="borrow-calculator-page">
        <div className="borrow-form-wrap">
          <div className="title primary">Your details</div>

          <div className="borrow-field-group">
            <label className="content primary">Calculator type</label>
            <CustomSelect
              options={calculatorOptions}
              value={selectedCalculator}
              onChange={(e) => setSelectedCalculator(e.target.value)}
              placeholder="Please select"
            />
          </div>

          <div className="result-divider investment-form-divider" />
        </div>

        {selectedCalculator === "investment-worth" && (
          <InvestmentWorthCalculator />
        )}
        {selectedCalculator === "investment-goal-monthly" && (
          <InvestmentGoalMonthlyCalculator />
        )}
        {selectedCalculator === "investment-goal-time" && (
          <InvestmentGoalTimeCalculator />
        )}
      </div>
    </div>
  );
};

export default InvestmentPage;
